__webpack_require__.p = "/bookmark-landing-page/";